import styled from 'foundations-theming-specialty/utils';
import { View } from 'foundations-components/transitional/components/View';
import { Flex } from 'foundations-components/components/Flex';
import { usePortalNavigation } from '../../hooks/usePortalNavigation';
import { hasHsRouteKeyCookie } from '../../utils/hsRouteKey';
import { PortalsSideNavItem } from './PortalsSideNavItem';
import { SiteMenuNavItem } from './SiteMenuNavItem';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const HsRouteKeyTape = styled.div.withConfig({
  displayName: "PortalsSideNav__HsRouteKeyTape"
})({
  position: 'absolute',
  insetBlockEnd: '0px',
  inlineSize: '60px',
  blockSize: '12px',
  borderRadius: '0px',
  backgroundImage: 'repeating-linear-gradient(-45deg, #FCC200 0 6px, #1A1A1A 6px 12px)',
  cursor: 'help'
});
export function PortalsSideNav({
  history,
  currentPathname
}) {
  const {
    navItems,
    siteMenuData
  } = usePortalNavigation(currentPathname);
  const showHsRouteKeyTape = hasHsRouteKeyCookie();
  return /*#__PURE__*/_jsxs(View, {
    as: "nav",
    "aria-label": "Portal navigation",
    children: [showHsRouteKeyTape && /*#__PURE__*/_jsx(HsRouteKeyTape, {
      title: "A preview route key is enabled",
      "aria-label": "A preview route key is enabled",
      "data-test-id": "portals-side-nav-hs-route-key-tape"
    }), /*#__PURE__*/_jsxs(Flex, {
      flexDirection: "column",
      alignItems: "center",
      gap: "400",
      children: [navItems.map(item => /*#__PURE__*/_jsx(PortalsSideNavItem, {
        item: item,
        history: history
      }, item.id)), siteMenuData && siteMenuData.items.length > 0 && /*#__PURE__*/_jsx(SiteMenuNavItem, {
        menuData: siteMenuData
      })]
    })]
  });
}